import { Injectable, OnDestroy } from '@angular/core';
import { Subject, Observable } from 'rxjs';

/**
 * CancelService - Centralized cancellation management for HTTP requests and polling
 * 
 * This service provides a global cancellation mechanism that is triggered on navigation.
 * Use the cancel$ observable with takeUntil() to automatically cancel subscriptions.
 */
@Injectable({
  providedIn: 'root'
})
export class CancelService implements OnDestroy {
  private cancelSubject = new Subject<void>();
  
  /**
   * Observable that emits when cancellation is requested.
   * Use with takeUntil() operator to auto-cancel subscriptions.
   * 
   * Example:
   * this.http.get(url).pipe(
   *   takeUntil(this.cancelService.cancel$)
   * ).subscribe();
   */
  public readonly cancel$: Observable<void> = this.cancelSubject.asObservable();

  /**
   * Triggers cancellation for all active subscriptions listening to cancel$
   * Should be called on navigation events to clean up pending operations
   */
  cancelAll(): void {
    this.cancelSubject.next();
  }

  ngOnDestroy(): void {
    this.cancelSubject.complete();
  }
}
